import React from "react";
import Icon from "material-ui-next/Icon";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import Dropzone from "react-dropzone";

const labels = {
  valid: "trocar o .csv",
  error: "trocar o .csv",
  absent: "anexar o .csv",
  invalid: "anexar um .csv válido"
};

const styles = {
  inner: {
    borderWidth: 2,
    borderColor: "#16303D",
    borderStyle: "dashed",
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: 200,
    opacity: 0.6,
    fontWeight: 350,
    fontSize: 22
  },
  outer: {
    margin: 15
  },
  placeholder: {
    fontWeight: 400,
    fontSize: 22,
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: "#F2B90D",
    textAlign: "center",
    marginBottom: 20
  },
  placeholderIcon: {
    fill: "#F2B90D",
    padding: 0,
    fontSize: "2em",
    display: "inline-block",
    verticalAlign: "middle"
  },
  placeholderContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center"
  },
  placeholderInvalid: {
    opacity: 1,
    color: "red"
  },
  placeholderInvalidIcon: {
    fill: "red",
    padding: 0,
    fontSize: "2em",
    display: "inline-block",
    verticalAlign: "middle"
  },
  placeholderValid: {
    opacity: 1,
    color: "green"
  },
  placeholderValidIcon: {
    fill: "green",
    padding: 0,
    fontSize: "2em",
    display: "inline-block",
    verticalAlign: "middle"
  }
};

const placeholders = {
  valid: (
    <div style={{ ...styles.placeholder, ...styles.placeholderValid }}>
      <Icon style={{ ...styles.placeholderValidIcon }}>done</Icon>
      Arquivo CSV válido!
    </div>
  ),
  error: (
    <div style={{ ...styles.placeholder, ...styles.placeholderInvalid }}>
      <Icon style={{ ...styles.placeholderInvalidIcon }}>not_interested</Icon>
      Esse arquivo contêm erros. Substitua-o.
    </div>
  ),
  absent: (
    <div style={styles.placeholder}>
      <Icon style={{ ...styles.placeholderIcon }}>warning</Icon>
      <span>Você ainda não enviou o arquivo CSV.</span>
    </div>
  ),
  invalid: (
    <div style={{ ...styles.placeholder, ...styles.placeholderInvalid }}>
      <Icon style={{ ...styles.placeholderInvalidIcon }}>not_interested</Icon>
      Ops! Esse arquivo é inválido. Tente novamente.
    </div>
  )
};

const BatchDropzone = ({ status, onFileSelect }) => (
  <Paper elevation={1} className="p-sm mb-md">
    <Typography type="headline">1ª Etapa - Enviar CSV</Typography>
    <Dropzone onDrop={onFileSelect} style={styles.outer} multiple={false}>
      <div style={styles.inner}>
        <div style={styles.placeholderContainer}>{placeholders[status]}</div>
        <span>Clique aqui para {labels[status]}</span>
        <span className="import-csv-instruction">
          ou arraste o arquivo até aqui.
        </span>
      </div>
    </Dropzone>
  </Paper>
);

export default BatchDropzone;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/dropzone/index.js